import {zDateTime} from '@brunata-angular/util';
import {z} from 'zod';

export const eventSchema = z
    .object({
        eventType: z.string(),
        severity: z.string(),
        action: z.string().nullable(),
        event: z
            .object({
                created: zDateTime.nullable(),
            })
            .transform(data => data.created)
            .nullable(),
    })
    .transform(data => ({
        eventType: data.eventType,
        severity: data.severity,
        action: data.action,
        created: data.event,
    }));
export type MeterEvent = z.infer<typeof eventSchema>;

export const meterSchema = z.object({
    meterNo: z.string(),
    printedSerialNo: z.string().nullable(),
    meterPlacement: z.string().nullable(),
    eventTypes: z.array(eventSchema),
});

export type Meter = z.infer<typeof meterSchema>;
